export default "__VITE_ASSET__f5336daa__"